export const IMPORT_PROFILE_STATUS_DESCRIPTION = {
    mapped: "import profile mapped description",
    data_warnings: "import profile data warnings description",
    data_errors: "import profile data errors description",
    warning: "import profile data warnings description",
    error: "import profile data errors description",
    skipped: "import profile skipped description",
    unmapped: "import profile not mapped description",
};

export const importProfileStatusDescriptionKey = (status) =>
    IMPORT_PROFILE_STATUS_DESCRIPTION[status] || IMPORT_PROFILE_STATUS_DESCRIPTION.unmapped;

const mappingStatusFromProfile = (profile) => {
    if (!profile) return "unmapped";
    if (profile.totalColumns > 0 && profile.mappedColumns === profile.totalColumns) return "mapped";

    const columns = profile.columns || [];
    const hasUnmappedColumn = columns.some((column) => column.status === "unmapped");
    const hasSkippedColumn = columns.some((column) => column.status === "skipped");
    const mappedColumns = profile.mappedColumns ?? 0;
    if (!hasUnmappedColumn && hasSkippedColumn && mappedColumns === 0) return "skipped";
    if (columns.length > 0 && !hasUnmappedColumn && mappedColumns > 0) return "mapped";

    return "unmapped";
};

export const importProfileStatusFromProfile = (profile) => {
    if (profile?.hasMapping === false) return "none";
    const mappingStatus = mappingStatusFromProfile(profile);
    if (mappingStatus === "unmapped") return "unmapped";
    if ((profile.errorCount ?? 0) > 0) return "data_errors";
    if ((profile.warningCount ?? 0) > 0) return "data_warnings";
    return mappingStatus;
};
